"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestRunner = void 0;
const filters_1 = require("./filters");
const requestRunner = (namespace, payload, store, successHelper, failureHelper) => (res) => payload.payload.type === 'AUTOMATIC' && res.files.length === 0
    ? failureHelper(namespace, {
        type: 'VALIDATION',
        errors: ['No files']
    })
    : successHelper(namespace, res.valid, res.files, (0, filters_1.filterReimportedUuids)(res.files, new Set(payload.payload.ids)), extractColorMetaId(store.value.files.metadata.list));
exports.requestRunner = requestRunner;
const extractColorMetaId = (list) => {
    const colorMeta = list.find((meta) => meta.identifier === 'color-meta');
    return colorMeta && colorMeta.id;
};
//# sourceMappingURL=responseProcessing.js.map